import { render, staticRenderFns } from "./IndexPerson.vue?vue&type=template&id=00d6b3a8&"
import script from "./IndexPerson.vue?vue&type=script&lang=js&"
export * from "./IndexPerson.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports